export const CARD_ON_SHARE_PER_PAGE = 50;
export const CARD_ON_CARD_LIST_PER_PAGE = 3;
